import '@/lib/util/overrides'
import Collection from './Collection'
import Axios from 'axios'
import qs from 'qs'

const { v4: uuidv4 } = require('uuid');

class Model {
    static idProperty;
    static session;
    static getter;
    static collectionGetter;
    static serviceUrl = '/service/index.aspx';
    static useAuthToken = false;
    authToken = null;
    associations = {};
    modified = null;
    associatedModified = false;
    api = [];
    fields = [];
    rootProperty = 'data';
    successProperty = 'meta.return_code';
    validateProp = null;
    busy = false;
    requestSource = null;
    loading = false;

    constructor (data, session) {
        var session = this.constructor.session = this.constructor.session || session;
        Object.assign(this, data || {});
        if (session) {
            session.commit('regRecord', this);
        }
    }

    get phantom () {
        var idProp = this.constructor.idProperty;
        if (idProp) {
            if (this.modified && this.modified[idProp]) {
                return false;
            }

            return !(this[idProp]);
        }
        else {
            return false;
        }
    }

    crud = {
        create (op, response, data) {
            if (data) {
                this.buildRawData(data);
                //this.phantom = false;
                this.commit();
            }
        }
        , read (op, response, data) {
            if (data) {
                this.buildRawData(data);
                //this.phantom = false;
                this.commit();
            }
        }
        , update (op, response, data) {
            if (data) {
                this.buildRawData(data);
                //this.phantom = false;
                this.commit();
            }
        }
        , destroy (op, response, data) {
            this.erase();
        }
    }

    getCrudData (name, associated) {
        var params = {}, cls = this.constructor;
        switch (name) {
            case 'create':
            case 'update':
                params = this.getData(associated);
                break;
            case 'read':
            case 'destroy':
                if (cls.idProperty) {
                    params[cls.idProperty] = this[cls.idProperty];
                }
                break;
        }
        return params;
    }

    getOperationData (operation, associated) {
        var paramNames = operation.params || []
            , params = {}, associations = this.associations
            , data = this.getData(associated);

        for (var i = 0; i < paramNames.length; i++) {
            if (typeof data[paramNames[i]] !== 'undefined') {
                if (!!this.associations[paramNames[i]] && data[paramNames[i]].getData) {
                    params[paramNames[i]] = data[paramNames[i]].getData();
                } else {
                    params[paramNames[i]] = data[paramNames[i]];
                }

            }
        }
        return params;
    }

    abortRequest () {
        if (this.requestSource) {
            this.requestSource.cancel();
        }
    }

    init () {
        var me = this
            , fields = me.fields, isDataSource = true, validate = false;

        for (var i = 0; i < fields.length; i++) {
            me.initField(i);
        }

        if (me.api) {
            for (var i = 0, op; i < me.api.length; i++) {
                op = me.api[i];
                isDataSource = !!op.dataSource;
                validate = op.validateData ? true : validate;
                me[op.name] = function (op) {
                    return function (opts) {
                        opts = opts || {};
                        var params = {}, isCrud = !!me.crud[op.name];
                        if (op.req && op.req.readyState == '1') {
                            return;
                        }
                        params = (op.params ? me.getOperationData(op, op.associated) : {});
                        if (opts.params) {
                            Object.assign(params, opts.params);
                        }
                        if (Object.isEmpty(params)) {
                            params = (isCrud ? me.getCrudData(op.name, op.associated) : me.getData(op.associated));
                        }
                        if (typeof op.validateData == 'function') {
                            params = op.validateData.call(me, params);
                        }
                        if (isDataSource) {
                            params = me.getDataSourceParams(op, params);
                        }
                        else {
                            params = Object.deepCopyPruned(params);
                        }

                        let request = Axios.create(),
                            defaultHeaders = { 'Content-Type': 'application/x-www-form-urlencoded' },
                            headers = Object.assign(defaultHeaders, opts.headers || {}, op.headers || {}),
                            method = op.method || 'POST',
                            cancelToken = Axios.CancelToken,
                            source = cancelToken.source();

                        if (Model.useAuthToken) {
                            headers['Authorization'] = `Bearer ${Model.getAuthToken()}`;
                        }

                        request.interceptors.request.use(
                            config => {
                                me.loading = true;
                                if (typeof opts.beforesend == 'function') {
                                    opts.beforesend.call(this);
                                }
                                return config;
                            }, error => {
                                me.loading = false;
                                if (typeof opts.failure == 'function') {
                                    opts.failure.call(this, op);
                                }
                            }
                        )

                        this.requestSource = source

                        if (method.toLowerCase() != 'get') {
                            if (op.json) {
                                params = qs.stringify({ json: JSON.stringify(params) })
                            } else if (headers['Content-Type'] == 'application/x-www-form-urlencoded') {
                                params = qs.stringify(params)
                            }
                        }

                        return op.req = request.request({
                            url: me.getUrl(op)
                            , method: method
                            , params: method.toLowerCase() == 'get' ? params : null
                            , data: method.toLowerCase() == 'get' ? null : params
                            , headers: headers
                            , cancelToken: source.token
                        }).then(response => {
                            response = response.data;
                            var returnCode = Object.getDescendant(response, op.successProperty || me.successProperty) || 0
                                , data = null;

                            me.loading = false;

                            if (response.meta && response.meta.auth_token) {
                                Model.setAuthToken(response.meta.auth_token);
                                Collection.setAuthToken(response.meta.auth_token);
                            }

                            if (returnCode == 0) {
                                data = Object.getDescendant(response, op.rootProperty || me.rootProperty);

                                if (typeof this.crud[op.name] == 'function') {
                                    this.crud[op.name].call(me, op, response, data, returnCode);
                                }
                                else if (data) {
                                    me.buildRawData(data);
                                }

                                if (typeof opts.success == 'function') {
                                    opts.success.call(this, op, response, data, returnCode);
                                }
                            }
                            else {
                                if (returnCode == 99 || returnCode == 89 || returnCode == 79 || returnCode == 69) {
                                    Model.removeAuthToken()
                                    var redirectPath = '/'
                                    if (response.data && response.data.redirect) {
                                        redirectPath = response.data.redirect
                                    }

                                    window.top.location = redirectPath;
                                }
                                else if (typeof opts.failure == 'function') {
                                    opts.failure.call(this, op, response, returnCode);
                                }
                            }

                            if (typeof opts.complete == 'function') {
                                opts.complete.call(this, op, response, data, returnCode);
                            }
                        })
                            .catch(function (error) {
                                me.loading = false;

                                // handle error
                                if (error.response) {
                                    // The request was made and the server responded with a status code
                                    // that falls out of the range of 2xx

                                    if (typeof opts.failure == 'function') {
                                        opts.failure.call(this, error, op);
                                    }
                                } else if (error.request) {
                                    // The request was made but no response was received
                                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                                    // http.ClientRequest in node.js

                                    if (typeof opts.failure == 'function') {
                                        opts.failure.call(this, error, op);
                                    }
                                } else {
                                    // Something happened in setting up the request that triggered an Error
                                    if (typeof opts.failure == 'function') {
                                        opts.failure.call(this, error, op);
                                    }
                                }

                                if (typeof opts.complete == 'function') {
                                    opts.complete.call(this, op, error);
                                }
                            })
                    };
                }(op);
            }
        }
    }

    getUrl (op) {
        var url = op.url;
        if (op.dataSource) {
            url = this.constructor.serviceUrl// need to call aspx page
        }
        return url;
    }

    getDataSourceParams (op, params) {
        return {
            dataSource: op.dataSource
            , params: JSON.stringify(Object.deepCopyPruned(params))
        }
    }

    initField (index) {
        var me = this
            , cls = this.constructor
            , field
            , fieldName
            , fieldType
            , defaultValue
            , mapping
            , value
            , initialValue
            , assoc
            , state
            , makeDirty
            , getter
            , session = me.constructor.session;

        field = me.fields[index];

        if (!field) {
            return;
        }

        defaultValue = typeof field == 'object' ? field.defaultValue : null;
        fieldType = typeof field == 'object' ? field.type : 'auto';
        mapping = typeof field == 'object' ? field.mapping : null;
        fieldName = typeof field == 'object' ? field.name : field;
        makeDirty = typeof field == 'object' ? field.makeDirty : true;
        getter = typeof field == 'object' && field.getter ? field.getter : function () { return value };

        if (mapping) {
            value = Object.getDescendant(me, mapping);
        }
        else {
            let fieldValue = me[fieldName];
            value = typeof fieldValue === 'undefined' ? defaultValue : fieldValue;
        }

        if (fieldType == 'bool') {
            /*eval is evil*/
            value = (value != undefined ? (value === 'true' || value === true ? true : false) : defaultValue);
        }
        else if (fieldType == 'int') {
            var val = parseInt(value)
            value = isNaN(val) ? 0 : val;
        }
        else if (fieldType == 'float') {
            value = typeof value === 'undefined' ? value : parseFloat(value);
        }

        if (typeof field == 'object') {
            assoc = field.association;
            if (assoc) {
                //state = assoc.model.name.toLowerCase() + 's';
                value = me.setAssociated(field, value);
            }
        }

        Object.defineProperty(me, fieldName, {
            enumerable: true
            , configurable: true
            , get: function () {
                return getter.call(me, value);
            }
            , set: function (val) {
                val = Object.isArray(val) || Object.isObject(val) ? val : (Object.isEmpty(val) ? null : val); // convert '' to null;
                if (value != val && makeDirty != false) {
                    if (me.modified == null) {
                        me.modified = {};
                    }

                    if (typeof me.modified[fieldName] == 'undefined') {
                        me.modified[fieldName] = value;
                    }
                    if (me.modified[fieldName] == val) {
                        delete me.modified[fieldName];
                    }
                }

                if (typeof field == 'object' && assoc) {
                    val = me.setAssociated(field, val);
                }

                if (value != val) {
                    value = val;

                    if (fieldName == me.constructor.idProperty && session) {
                        session.commit('regRecord', me);
                    }
                }
            }
        });

        if (me[fieldName] != value) {
            me[fieldName] = value;
        }
    }

    setAssociated (field, value, initialValue) {
        var me = this
            , assoc = field.association
            , assocValue
            , session = assoc.model.session || this.constructor.session

        this.insertAssociation(assoc, field.name);
        // we can put extra relationship for child association to parent to check is child record modified
        if (assoc.type == 'many') {
            if (!value) {
                value = [];
            }
            if (typeof value == 'object' && typeof value.length == 'undefined') {
                value = [value]; // to array
            }
            if (Array.isArray(value)) {
                /*
                    Setting many association as collection
                    If association already created then use that collection
                    And replace existing records with the newly created records from the database
                */
                var collection = this[assoc.name];
                if (!collection || (collection && !collection.add)) {
                    var collectionConfig = Object.assign((assoc.collectionConfig || {}), { model: assoc.model });
                    collection = new Collection(collectionConfig, session);
                    collection._associatedOwner = this;
                }
                else if (!session && collection.length > 0) {
                    collection.removeAll();
                }
                for (var i = 0; i < value.length; i++) {
                    if (!(value[i] instanceof assoc.model)) {
                        assocValue = me.getAssociatedRecord(value[i], assoc);
                    }
                    else {
                        assocValue = value[i];
                    }
                    collection.add(assocValue);
                }
                value = collection;
            }
        }
        else if (assoc.type == 'one') {
            assocValue = me.getAssociatedRecord(value, assoc);

            if (assoc.name && field.name != assoc.name) {
                if (!me.hasOwnProperty(assoc.name)) {
                    Object.defineProperty(me, assoc.name, {
                        enumerable: true
                        , configurable: true
                        , get: function () {
                            return assocValue;
                        }
                        , set: function (val) {
                            val = Object.isArray(val) || Object.isObject(val) ? val : (Object.isEmpty(val) ? null : val); // convert '' to null;
                            if (assocValue != val && field.makeDirty != false) {
                                if (me.modified == null) {
                                    me.modified = {};
                                }

                                if (typeof me.modified[assoc.name] == 'undefined') {
                                    me.modified[assoc.name] = assocValue;
                                }
                                if (me.modified[assoc.name] == val) {
                                    delete me.modified[assoc.name];
                                }
                            }

                            assocValue = val;
                        }
                    });
                }

                if (me[assoc.name] != assocValue) {
                    me[assoc.name] = assocValue;
                }
            }
            else if (value != assocValue) {
                value = assocValue;
            }
        }

        return value;
    }

    getAssociatedRecord (value, assoc) {
        var rec, data = {}, session;

        if (assoc.model.idProperty && (session = assoc.model.session || this.constructor.session)) {
            if (value && !Object.isObject(value)) {
                rec = session.getters.getRecord(assoc.model.name, value);
                if (!(rec instanceof assoc.model)) {
                    data[assoc.model.idProperty] = value;
                    rec = new assoc.model(data, session);
                }
            }
            else if (value) {
                if (!(value instanceof assoc.model)) {
                    var idProp = assoc.idProperty || assoc.model.idProperty;
                    rec = session.getters.getRecord(assoc.model.name, value[idProp]);
                    if (!(rec instanceof assoc.model)) {
                        if (idProp != assoc.model.idProperty) {
                            value[assoc.model.idProperty] = value[idProp];
                            delete value[idProp];
                        }
                        data = value;
                        rec = new assoc.model(data, session);
                    }
                    else {
                        if (idProp != assoc.model.idProperty) {
                            value[assoc.model.idProperty] = value[idProp];
                            delete value[idProp];
                        }
                        rec.setData(value);
                    }
                }
                else {
                    rec = value;
                }
            }

            value = rec;
        }
        else {
            if (value && !Object.isObject(value)) {
                data[assoc.model.idProperty] = value;
                value = new assoc.model(data);
            }
            else if (typeof value == 'object' && !(value instanceof assoc.model)) {
                value = new assoc.model(value);
            }
        }

        if (value instanceof assoc.model && assoc.foreignKey) {
            value[assoc.foreignKey] = this[this.constructor.idProperty];
        }
        else if (!(value instanceof assoc.model)) {
            value = new assoc.model(data, session);
        }

        return value;
    }

    insertAssociation (assoc, fieldName) {
        assoc.name = assoc.name || fieldName;
        var associations = this.associations;
        if (!associations[fieldName]) {
            associations[fieldName] = assoc;
        }
    }

    commit () {
        this.modified = null;
        var associations = this.associations;

        if (!Object.isEmpty(associations)) {
            this.busy = true;
            for (var p in associations) {
                var assoc = associations[p]
                    , assocRecord = this[assoc.name];

                if (assoc.type == 'many') {
                    assocRecord.commit();
                }
                else {
                    if (assocRecord.busy) {
                        continue;
                    }
                    if (assocRecord.isModified()) {
                        assocRecord.commit();
                    }
                }
            }
            this.busy = false;
        }
    }

    reject () {
        this.busy = true;

        var rejectFn = function (record) {
            if (record.modified != null) {
                for (var p in record.modified) {
                    record[p] = record.modified[p];
                }
                record.commit();
            }
        }
        rejectFn(this);

        var associations = this.associations;
        for (var p in associations) {
            var assoc = associations[p]
                , assocRecord = this[assoc.name];

            if (assoc.type == 'many') {
                assocRecord.reject();
            }
            else {
                if (assocRecord.busy) {
                    continue;
                }
                assocRecord.reject();
            }
        }
        this.busy = false;
    }

    isModified () {
        var modified = Object.getLength(this.modified) > 0
            , associations = this.associations;

        if (!modified && !Object.isEmpty(associations)) {
            this.busy = true;

            for (var p in associations) {
                var assoc = associations[p]
                    , assocRecord = this[assoc.name];

                if (assoc.type == 'many') {
                    modified = assocRecord.isModified();
                }
                else {
                    if (assocRecord.busy) {
                        continue;
                    }
                    modified = assocRecord.isModified();
                }

                if (modified) {
                    break;
                }
            }

            this.busy = false;
        }
        return modified;
    }

    getData (props) {
        /*
            This method is used for getting the desired data from the model
            You can copy whole model like new Model(model.getData(true))
            It will copy all associations with their corresponding values
        */
        this.busy = true;
        if (this.validateProp && this[this.validateProp] == false) {
            return null;
        }

        var data = {};

        for (var i = 0; i < this.fields.length; i++) {
            var field = this.fields[i]
                , fieldName = typeof field == 'object' ? field.name : field
                , postName = typeof field == 'object' ? field.postName || fieldName : fieldName
                , hasAssociation = !!this.associations[fieldName]
                , isParameterObject = Object.isObject(props)
                , assoc;

            if (props === false) {
                continue;
            }
            else if (isParameterObject && props[fieldName] === false) {
                continue;
            }
            else if (hasAssociation) {
                assoc = this.associations[fieldName];

                if (assoc.type == 'one' && this[fieldName].busy == true) {
                    continue;
                }

                /*
                    If it is an associated field
                    Check if it is exist in the props argument or
                    If props argument is just true, get all properties for the associated field.
                    If props not true at that time it must be mentioned in the props object as true like: Parent:{Associated:true}
                */

                if (props) {
                    if (props == true || (isParameterObject && props[fieldName])) {
                        var fn = props[fieldName] && props[fieldName].filterFn ? props[fieldName].filterFn : this[fieldName].getData;
                        data[postName] = fn.call(this[fieldName], isParameterObject ? props[fieldName] : props);
                    }
                }
                else {
                    data[postName] = this[fieldName].getData();
                }
            }
            else if (isParameterObject && props[fieldName] && typeof props[fieldName].filterFn == 'function') {
                data[postName] = props[fieldName].filterFn.call(this[fieldName]);
            }
            else {
                data[postName] = this[fieldName];
            }
        }
        this.busy = false;
        return data;
    }

    setData (data, commit) {
        this.buildRawData(data);
        if (commit != false) {
            this.commit();
        }
    }

    buildRawData (rawData) {
        var fields = this.fields
            , idProp = this.constructor.idProperty
            , session = this.constructor.session;
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i]
                , fieldName = typeof field == 'object' ? field.name : field
                , fieldType = typeof field == 'object' ? field.type : 'auto'
                , preserve = typeof field == 'object' ? (typeof field.preserve == 'boolean' ? field.preserve : true) : true
                , mapping = typeof field == 'object' ? field.mapping : null
                , value = mapping ? Object.getDescendant(rawData, mapping) || rawData[fieldName] : rawData[fieldName];

            if (session) {
                if (fieldName == idProp && this[idProp] != rawData[idProp]) {
                    if (!this[idProp]) {
                        this[idProp] = rawData[idProp];
                        session.commit('regRecord', this);
                    }
                }
            }

            value = preserve != true ? value : Object.isArray(value) || Object.isObject(value) ? value : (!Object.isEmpty(value) ? value : this[fieldName])

            if (fieldType == 'int') {
                value = parseInt(value)
                value = isNaN(value) ? null : value
            } else if (fieldType == 'float') {
                value = parseFloat(value)
                value = isNaN(value) ? null : value
            } else if (fieldType == 'bool') {
                value = (value == 'true' || value == true ? true : false)
            }

            this[fieldName] = value;
        }
    }

    serialize (associated) {
        return (JSON.stringify(Object.deepCopyPruned(this.getData(associated))));
    }

    erase () {
        var cls = this.constructor;
        if (cls.collectionGetter && cls.session) {
            var collection = cls.session.state[cls.collectionGetter];
            collection.splice(collection.indexOf(this), 1);
        }
        if (cls.session) {
            cls.session.commit('evict', this);
        }
    }

    generateId () {
        this[this.constructor.idProperty] = uuidv4();
    }
}

export default Model;
